import { Component, OnInit, OnDestroy } from '@angular/core';
import { IconsService }      from '@omnipas/services/icons.service';
import { ListService }       from '@omnilib/services/list.service';
import { RouterService }     from '@omnipas/services/router.service';

@Component({
  selector: 'omnipas-permissionsinfo',
  templateUrl: './permissionsinfo.component.html'
})
export class PermissionsInfoComponent implements OnInit, OnDestroy {

  params;

  constructor ( public icons:   IconsService
              , public list:    ListService
              , public router:  RouterService
              ) {
  }

  ngOnInit() {
  }

  hide() {
    this.router.showpermissionsinfo = false;
  }

  showDisclaimer() {
  }

  showTerms() {
  }

  ngOnDestroy() {
    return;
  }
}
